import {
  Middleware,
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit'
import { createLogger } from 'redux-logger'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import useAuthSlice from '../hooks/Auth/authSlice'
import mainSlice from '../hooks/Auth/mainSlice'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
}

const rootReducer = combineReducers({
  auth: useAuthSlice,
  main: mainSlice,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

// Create the logger middleware using createLogger
const logger = createLogger()

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat(logger as Middleware),
})

const persistor = persistStore(store)

export { store, persistor }
